import React, { useEffect, useState } from "react";
import PaymentHistoryListing from "./PaymentHistoryListing";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setPage,
  setRowsPerPage,
  setSearchValue,
  setIsTableLoading,
  setItems,
  setTotalItems,
} from "src/redux/slices/PaymentHistorySlice";
import { formatedDateTimeIntoIst } from "src/utils/formUtils/dateTimeFormate";
import { useParams } from "react-router-dom";
import { useGetTransactionsQuery } from "src/services/TransactionsServices";
import { Chip } from "@mui/material";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import UpdatePaymentDialogFormWrapper from "../UpdatePaymentDialog/UpdatePaymentDialogFormWrapper";

type Props = {};

const PaymentHistoryListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const { studentId = "" } = useParams();
  const [openUpdateDialog, setOpenUpdateDialog] = useState(false);
  const [totalAmount, setTotalAmount] = useState("");
  const[transactionId , setTransactionId] = useState('')
  const { items, totalItems, page, rowsPerPage, searchValue, isTableLoading } =
    useSelector((state: RootState) => state.paymentHistory);

  const { data, isLoading, isFetching } = useGetTransactionsQuery({
    limit: 10,
    searchValue: "",
    params: ["studentLabel"],
    page: 0,
    filterBy: [
      {
        fieldName: "studentId",
        value: studentId,
      },
    ],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: false,
  });

  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setTotalItems(data?.totalItem || 0));
      dispatch(setIsTableLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);

  const columns: columnTypes[] = [
    {
      field: "createdAt",
      headerName: "Date - Time",
      extraClasses: "max-w-[150px] py-1",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => (
        <div>
          <div className="text-slate-700 font-medium">
            {formatedDateTimeIntoIst(row.createdAt, "DD MMM yyyy")}
          </div>
          <div className="text-[13px] font-medium text-slate-400">
            {formatedDateTimeIntoIst(row.createdAt, "hh:mm A")}
          </div>
        </div>
      ),
    },
    {
      field: "paymentDate",
      headerName: "Payment Date",
      flex: "flex-[1_1_0%]",
      extraClasses: "max-w-[200px]",
      renderCell: (row: any) => (
        <div className="text-slate-700 font-medium"> {formatedDateTimeIntoIst(row.paymentDate, "DD MMM yyyy")} </div>
      ),
    },
    {
      field: "amount",
      headerName: "Amount",
      flex: "flex-[1_1_0%]",
      extraClasses: "max-w-[150px]",
      align: "center",
      renderCell: (row: any) => <div> &#8377; {row?.amount} </div>,
    },
    {
      field: "accountLabel",
      headerName: "Account",
      flex: "flex-[1_1_0%]",
      extraClasses: "max-w-[250px]",
      renderCell: (row: any) => <div>{row?.accountLabel} </div>,
    },
    {
      field: "mode",
      headerName: "Mode",
      flex: "flex-[1_1_0%]",
      extraClasses: "max-w-[200px]",
      renderCell: (row: any) => <div>{row?.mode} </div>,
    },
    {
      field: "coupon",
      headerName: "Coupon",
      flex: "flex-[1_1_0%]",
      extraClasses: "max-w-[150px]",
      renderCell: (row: any) => (
        <div>{row?.coupon ? <Chip label={row?.coupon} /> : "-"} </div>
      ),
    },
    {
      field: "couponDiscount",
      headerName: "Coupon-Discount",
      flex: "flex-[1_1_0%]",
      extraClasses: "max-w-[150px]",
      renderCell: (row: any) => <div> &#8377; {row?.couponDiscount || 0} </div>,
    },
    {
      field: "isEdited",
      headerName: "Edited",
      flex: "flex-[1_1_0%]",
      extraClasses: "max-w-[150px]",
      renderCell: (row: any) => <div className="font-medium">  {row?.isEdited ? <div className="text-green-700 text-[14px]">YES</div> :<div className="text-red-700 text-[14px]">NO</div>} </div>,
    },
    {
      field: "previousAmount",
      headerName: "Actual Installment Amount",
      flex: "flex-[1_1_0%]",
      extraClasses: "max-w-[150px]",
      renderCell: (row: any) => <div>&#8377;  {row?.previousAmount || 0} </div>,
    },
    {
      field: "remark",
      headerName: "Remark",
      flex: "flex-[1_1_0%]",
      extraClasses: "max-w-[150px]",
      renderCell: (row: any) => <div className=""> {row?.remark} </div>,
    },
    {
      field: "update",
      headerName: "Update",
      flex: "flex-[1_1_0%]",
      extraClasses: "max-w-[150px]",
      renderCell: (row: any) => {
        return (
          <div>
            <ATMLoadingButton
              className="h-[30px]"
              onClick={() => {
                setOpenUpdateDialog(true);
               
                setTotalAmount(row?.amount);
                setTransactionId(row?._id)
              }}
            >
              Update
            </ATMLoadingButton>
          </div>
        );
      },
    },
  ];

  return (
    <div className="h-full">
      <PaymentHistoryListing
        columns={columns}
        rows={items}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
      />
      {openUpdateDialog && (
        <UpdatePaymentDialogFormWrapper
         
          amount={totalAmount}
          setTotalAmount={setTotalAmount}
       
          setTransactionId={setTransactionId}
          transactionId={transactionId}
          onClose={() => {
            setOpenUpdateDialog(false);
          }}
        />
      )}
    </div>
  );
};

export default PaymentHistoryListingWrapper;
